import { useEffect, useState } from 'react';

export const useFetcher = (path,method="GET") => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetcher = async () => {
      const res = await fetch(`https://hamrahyper.ir/api/${path}`,{method:method});
      const data = await res.json();
      if(path=='')localStorage.setItem('maxCart',data.maxCartSelectable);
      setData(data);
      setLoading(false);
    };
    fetcher();
    
  }, [path]);

  return [data, loading];
};
